import { render, staticRenderFns } from "./ProductLabels.vue?vue&type=template&id=3709956f&scoped=true"
import script from "./ProductLabels.vue?vue&type=script&lang=js"
export * from "./ProductLabels.vue?vue&type=script&lang=js"
import style0 from "./ProductLabels.vue?vue&type=style&index=0&id=3709956f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3709956f",
  null
  
)

export default component.exports